<template>
    <div class="direct-messages-list">
        <div
            aria-label="Direct Messages"
            class="p-channel_sidebar__static_list__item p-channel_sidebar__static_list__item--contain c-virtual_list__item"
            tabindex="-1"
        >
            <div
                :class="[
                        'slack-channels-heading',
                        'p-channel_sidebar__section_heading',
                        'p-channel_sidebar__drop_target_indicator',
                        {
                            'p-channel_sidebar__section_heading--collapsed':
                                !is_channels_menu_active,
                        },
                        {
                            'p-channel_sidebar__section_heading--empty':
                                !is_channels_menu_active,
                        },
                        { 'slack-menu-active': is_channels_menu_active },
                    ]"
                @click="is_channels_menu_active = !is_channels_menu_active"
            >
                <span
                    class="p-channel_sidebar__section_heading_expand_container"
                    aria-hidden="true"
                ><i
                        class="
                                c-icon
                                c-icon--caret-right
                                c-icon--inherit
                                c-icon--inline
                                p-channel_sidebar__section_heading_expand
                            "
                        type="caret-right"
                        aria-hidden="true"
                    ></i></span>
                <div class="
                            slack-heading-label
                            p-channel_sidebar__section_heading_label--clickable
                        ">
                    <span class="
                                p-channel_sidebar__section_heading_label_overflow
                            ">Direct messages</span>
                </div>
            </div>
        </div>
        <div class="direct-messages-list-container">
            <div class="direct-messages-search-box-container" v-show="is_channels_menu_active || (!!selected_item && selected_item.is_im)">
                <o-input
                    class="search-box"
                    placeholder="Search..."
                    icon="magnify"
                    size="is-small"
                    type="search"
                    v-model="search_term"
                />
            </div>

            <div
                class="p-channel_sidebar__static_list__item p-channel_sidebar__static_list__item--contain c-virtual_list__item"
                v-for="(item, key) in filtered"
                v-show="should_show_channel(item)"
                :key="`channel-${key}`"
            >
                <div
                    :class="['p-channel_sidebar__close_container', {'p-channel_sidebar__channel--selected': is_channel_selected(item)}]"
                    @click="handleSlackLabelMenu(item)"
                >
                    <div
                        :class="['p-channel_sidebar__channel', {'p-channel_sidebar__channel--im-you': is_me(item.user_info.id)}]"
                        data-qa-channel-sidebar-channel="true"
                        data-qa-channel-sidebar-channel-is-selected="false"
                        data-qa-channel-sidebar-channel-is-muted="false"
                        data-qa-channel-sidebar-channel-type="im"
                        data-qa-channel-sidebar-is-starred="false"
                        draggable="true"
                    >
                        <div class="p-channel_sidebar__user_avatar"><span
                                class="c-avatar"
                                data-qa="channel-prefix-im-avatar"
                                style="height: 20px; width: 20px;"
                            ><img
                                    :src="item.user_info.profile.image_24"
                                    srcset="https://ca.slack-edge.com/T01NZJV2ADU-U02DRRJCURL-g663367a9597-48 2x"
                                    class="c-base_icon c-base_icon--image"
                                    aria-hidden="true"
                                    role="img"
                                    alt=""
                                    style="height: 20px; width: 20px; min-width: 20px;"
                                ></span>
                        </div>
                        <span
                            dir="auto"
                            class="p-channel_sidebar__name"
                            delay="300"
                            data-sk="tooltip_parent"
                        >
                            <span>{{item.user_info.real_name}}</span>
                            <span
                                class="p-channel_sidebar__member_label"
                                data-qa="channel_sidebar_name_you"
                                v-if="is_me(item.user_info.id)"
                            >you</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { is_me } from '../../slack_api'
export default {
    components: {
    },
    computed: {
        filtered() {
            if (this.search_term) {
                const re = new RegExp(`.*${this.search_term}.*`,'gi')
                return this.channels.filter(ch => re.test(ch.real_name) || re.test(ch.user_info.profile.email))
            }
            return this.channels
        },
    },
    data() {
        return {
            is_channels_menu_active: false,
            search_term: '',
        }
    },
    methods: {
        handleSlackLabelMenu(item) {
            this.$emit('onselected', item)
            this.$router.push({ name: 'slack.channel', params: { id: item.id } })
        },
        is_channel_selected(item) {
            return (this.selected_item && this.selected_item.id === item.id)
        },
        is_me,
        should_show_channel(item) {
            return this.is_channels_menu_active || this.is_channel_selected(item)
        },
    },
    mounted() {
    },
    props: ['channels', 'selected_item'],
    watch: {
    },
}
</script>
<style>
.direct-messages-list .slack-channels-heading.p-channel_sidebar__section_heading {
  padding-left: 14px; }

.direct-messages-list .direct-messages-list-container {
  max-height: 280px;
  overflow: auto; }
.direct-messages-list .direct-messages-list-container .direct-messages-search-box-container {
  padding-left: 15px;
  padding-right: 7px;
  padding-bottom: 5px; }
.direct-messages-list .direct-messages-list-container .direct-messages-search-box-container input[type=search] {
  height: 16px; }
</style>